import { NextResponse } from "next/server";
import axios from "axios";

const LOGIN_REDIRECT_URL = process.env.WEBSITE_URL + 'register/influencer/steps/';
const PROFILE_REDIRECT_URL = process.env.WEBSITE_URL + 'influencer/profile/social-media-account/';

export async function POST(req) {
  try {
    const { code, type } = await req.json();

    const REDIRECT_URL =
      type === "profile" ? PROFILE_REDIRECT_URL : LOGIN_REDIRECT_URL;

    const formData = new URLSearchParams();
    formData.append("client_key", process.env.TIKTOK_CLIENT_ID);
    formData.append("client_secret", process.env.TIKTOK_SECRET_ID);
    formData.append("grant_type", "authorization_code");
    formData.append("redirect_uri", REDIRECT_URL);
    formData.append("code", code);

    // console.log("formData", formData);+

    const response = await axios.post(
      "https://open.tiktokapis.com/v2/oauth/token/",
      formData.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    
    return NextResponse.json({ data: response.data });
  } catch (error) {
    console.error("Error during Tiktok token exchange:", error);
    return NextResponse.json(
      { error: "Tiktok token exchange failed" },
      { status: 500 }
    );
  }
}
